import { FC } from 'react'
import { Button, ButtonVariants } from '@/components/Button'
import { OpenAccountButton } from '@/components/OpenAccount/OpenAccountButton'
import { Colour } from '@/components/constants'
import { Link } from '@/components/Link'
import cx from 'classnames'
import styles from './styles.module.scss'
import { DownloadButton } from '@/components/DownloadButton'
import { CmsAsset } from '..'

export interface HeroCtaProps {
  className?: string
  primaryCtaText?: string
  primaryCtaUrl?: string
  secondaryCtaText?: string
  secondaryCtaUrl?: string
  linkUrl?: string
  linkText?: string
  showOpenAccountButton?: boolean
  openAccountButtonText?: string
  backgroundColour?: Colour
  downloadButtonText?: string
  downloadableAsset?: CmsAsset
}

export const HeroCtas: FC<HeroCtaProps> = ({
  className,
  primaryCtaText,
  primaryCtaUrl,
  secondaryCtaText,
  secondaryCtaUrl,
  linkUrl,
  linkText,
  backgroundColour,
  showOpenAccountButton,
  openAccountButtonText,
  downloadButtonText,
  downloadableAsset,
}) => {
  const hasContent = () =>
    (primaryCtaText && primaryCtaUrl) ||
    (secondaryCtaText && secondaryCtaUrl) ||
    (linkText && linkUrl) ||
    showOpenAccountButton ||
    (downloadButtonText && downloadableAsset)

  return (
    <>
      {hasContent() && (
        <div className={cx(styles.heroCtas, className)}>
          {showOpenAccountButton && (
            <OpenAccountButton text={openAccountButtonText} />
          )}
          {primaryCtaText && primaryCtaUrl && (
            <Button url={primaryCtaUrl}>{primaryCtaText}</Button>
          )}
          {secondaryCtaText && secondaryCtaUrl && (
            <Button
              variant={ButtonVariants.SECONDARY}
              backgroundColour={backgroundColour}
              url={secondaryCtaUrl}
            >
              {secondaryCtaText}
            </Button>
          )}
          {linkUrl && linkText && (
            <Link
              className={styles.heroLink}
              url={linkUrl}
              backgroundColour={backgroundColour}
            >
              {linkText}
            </Link>
          )}
          {downloadButtonText && downloadableAsset && (
            <DownloadButton
              downloadButtonText={downloadButtonText}
              downloadableAsset={downloadableAsset}
            />
          )}
        </div>
      )}
    </>
  )
}

HeroCtas.displayName = 'Hero Ctas'
